var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUberHealth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6991 5.0757V8.17919L13.2944 8.82131C13.1543 9.03534 12.9053 9.17294 12.6406 9.17294H1.09116C0.826549 9.17294 0.577502 9.03534 0.437415 8.82131L0.0327148 8.17919V5.0757C0.0327148 4.72408 0.126109 4.37245 0.328458 4.06667L0.842113 3.25639L2.42978 0.718546C2.53874 0.550378 2.66325 0.412782 2.81892 0.305764C3.08351 0.107018 3.41039 0 3.73726 0H9.97896C10.3214 0 10.6327 0.107018 10.8973 0.305764C11.053 0.412782 11.1775 0.565664 11.2864 0.718546L12.8897 3.25639L13.4033 4.06667C13.6057 4.37245 13.6991 4.72408 13.6991 5.0757Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27784 2.01807H0.234963C0.0948735 2.01807 -0.0140814 2.14037 0.0014827 2.27797L0.0481781 2.64489C0.141572 2.99652 0.468443 3.2564 0.842012 3.2564H1.51132V2.24739C1.51132 2.12508 1.41793 2.01807 1.27784 2.01807Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4225 2.01807H13.4653C13.6054 2.01807 13.7144 2.14037 13.6988 2.27797L13.6521 2.64489C13.5587 2.99652 13.2319 3.2564 12.8583 3.2564H12.189V2.24739C12.189 2.12508 12.2823 2.01807 12.4225 2.01807Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.904297 5.198V5.48846C0.904297 5.65664 1.01325 5.79424 1.16891 5.84009L3.51926 6.6198L4.35981 5.198H0.904297Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8271 5.198V5.48846C12.8271 5.65664 12.7181 5.79424 12.5625 5.84009L10.2121 6.6198L9.37158 5.198H12.8271Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6015 7.85832L11.0062 8.31696C11.1152 8.43927 11.1774 8.59216 11.1774 8.74502V9.57058H2.56982V8.74502C2.56982 8.59216 2.63207 8.43927 2.74105 8.31696L3.14575 7.85832C3.27026 7.72072 3.44147 7.64429 3.62827 7.64429H10.1035C10.2902 7.64429 10.477 7.72072 10.6015 7.85832Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0372 0.87148C10.8037 0.504563 10.4146 0.290527 9.97877 0.290527H3.75263C3.31681 0.290527 2.92767 0.504563 2.69418 0.87148L1.51123 2.76721H12.2357L11.0372 0.87148Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59053 6.6937L9.13064 6.85027H4.55744L4.11035 6.6937L4.78739 5.48022H8.90072L9.59053 6.6937Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5586 3.42501H1.1416L2.64423 1.46104C2.74735 1.3309 2.86519 1.22442 3.01253 1.1416H10.673C10.8203 1.22442 10.9381 1.34273 11.0413 1.46104L12.5586 3.42501Z",
    fill: "#F5F5F5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25088 9.20365H5.48026C5.37128 9.20365 5.29346 9.11193 5.29346 9.0202V8.54627C5.29346 8.43925 5.38684 8.36279 5.48026 8.36279H8.25088C8.35983 8.36279 8.43765 8.45455 8.43765 8.54627V9.0202C8.45322 9.12722 8.35983 9.20365 8.25088 9.20365Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUberHealth);
export default __webpack_public_path__ + "static/media/uberHealth.4ec0db07e420e2fc80d5daf5aae21d8c.svg";
export { ForwardRef as ReactComponent };